import { css } from 'styled-components';

export const SharedListStyle = css`
  padding-inline-start: 27px;
  position: relative;
  ul,
  ol {
    padding-inline-start: 20px;
  }
  li {
    padding-left: 3px;
  }
`;

export const SharedCustomBulletPointStyle = css``;
